import { render, staticRenderFns } from "./inspectionRecord.vue?vue&type=template&id=d1279dc4&scoped=true"
import script from "./inspectionRecord.vue?vue&type=script&lang=js"
export * from "./inspectionRecord.vue?vue&type=script&lang=js"
import style0 from "./inspectionRecord.vue?vue&type=style&index=0&id=d1279dc4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1279dc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1279dc4')) {
      api.createRecord('d1279dc4', component.options)
    } else {
      api.reload('d1279dc4', component.options)
    }
    module.hot.accept("./inspectionRecord.vue?vue&type=template&id=d1279dc4&scoped=true", function () {
      api.rerender('d1279dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/inspectionRecord.vue"
export default component.exports